import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fillAddressAction } from '@r1-frontend/entities/ContactAddress/actions/fillAddress';
import { isAddressFilled } from '@r1-frontend/entities/ContactAddress/selectors/isAddressFilled';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { BaseButton, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { PolicyNote } from '@r1-frontend/ui-react/components/PolicyNote';
import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';
import { IAddress } from '@r1-frontend/shared/types/IAddress';

import AddressInputFields from '~/src/components/AddressInputFields';
import { openCitySelect } from '~/src/components/CitySelectContainer/store/actionCreators';
import { POLICY_PAGE_LINK } from '~/src/constants';
import { TState } from '~/src/store';

import * as ST from './styled';

const sendGtmEvent = (action: string) => {
    dataLayerPush({
        event: EVENTS.UAevent,
        category: 'main-page',
        action,
    });
};

export type TProps = {
    onConfirmBtnClick: () => void,
}

const EditableAddressForm = ({
    onConfirmBtnClick,
}: TProps): JSX.Element => {
    const dispatch = useDispatch();

    const {
        isConfirmButtonActive,
    } = useSelector((state: TState) => ({
        isConfirmButtonActive: isAddressFilled(state),
    }));

    const onFillAddress = useCallback((address: IAddress) => {
        dispatch(fillAddressAction(address));
    }, [dispatch]);

    const openCitySelectPopup = useCallback(() => dispatch(openCitySelect()), [dispatch]);

    const buttonText = 'Проверить адрес';

    return (
        <ST.EditableAddressForm>
            <ST.BlockWrap>
                <AddressInputFields
                    catchAddressData={onFillAddress}
                    disableCityChange={false}
                    gtmCategory={CATEGORIES.fullBuy}
                    gtmSenderCallback={sendGtmEvent}
                    onClickCityChange={openCitySelectPopup}
                />
            </ST.BlockWrap>
            <ST.AgreeWrap>
                <PolicyNote
                    agreeUrl={POLICY_PAGE_LINK}
                    buttonText={buttonText}
                />
                <BaseButton
                    data-test='check-address-btn'
                    type={btnTypes.ACCENT}
                    text={buttonText}
                    onClick={onConfirmBtnClick}
                    disabled={!isConfirmButtonActive}
                />
            </ST.AgreeWrap>
        </ST.EditableAddressForm>
    );
};

export default memo(EditableAddressForm);
